/* __next_internal_client_entry_do_not_use__ Default,LatestArticlesCards auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { withStandardComponentWrapper } from 'helpers/HOC';
import { useRealPathName } from 'lib/hooks/useRealPathName';
import NewsListSearchWidget from 'widgets/NewsList';
import LatestArticleCardsSearchWidget from 'widgets/LatestArticleCards';
const ExpertCommentsOnNews = (props)=>{
    const path = useRealPathName();
    const ExpertCommentsOnNewsData = {
        title: props?.fields?.data?.datasourceItem?.title?.jsonValue,
        description: props?.fields?.data?.datasourceItem?.description?.jsonValue,
        link: props?.fields?.data?.datasourceItem?.link?.jsonValue,
        params: props?.params,
        id: props?.params?.RenderingIdentifier,
        uid: props?.rendering?.uid
    };
    return /*#__PURE__*/ _jsx(NewsListSearchWidget, {
        rfkId: 'rfkid_reports_insights',
        ...ExpertCommentsOnNewsData
    }, path);
};
const LatestArticlesCardsVariant = (props)=>{
    const path = useRealPathName();
    const { smallContainer } = props?.params || {};
    const isSmallContainer = smallContainer === '1';
    const LatestArticlesCardsData = {
        defaultItemsPerPage: isSmallContainer ? 2 : 3,
        title: props?.fields?.data?.datasourceItem?.title?.jsonValue,
        description: props?.fields?.data?.datasourceItem?.description?.jsonValue,
        link: props?.fields?.data?.datasourceItem?.link?.jsonValue,
        params: props?.params,
        id: props?.params?.RenderingIdentifier,
        uid: props?.rendering?.uid,
        latestArticles: props?.fields?.data?.item?.latestArticles?.targetItems
    };
    return /*#__PURE__*/ _jsx(LatestArticleCardsSearchWidget, {
        rfkId: 'rfkid_reports_insights',
        ...LatestArticlesCardsData
    }, path);
};
export const Default = withStandardComponentWrapper(ExpertCommentsOnNews);
export const LatestArticlesCards = withStandardComponentWrapper(LatestArticlesCardsVariant);
